export default __webpack_public_path__ + "static/media/govmansion.f842eb2f.jpeg";